import styled from "styled-components"

export interface SummaryRow {
  label: string
  value: string
}

interface SummaryCardProps {
  title: string
  rows: SummaryRow[]
  onEdit?: () => void
}

/** Card de resumo (Etapa 4): título + botão Editar + linhas rótulo/valor. */
export const SummaryCard = ({ title, rows, onEdit }: SummaryCardProps) => (
  <Card>
    <Head>
      <Title>{title}</Title>
      {onEdit && (
        <EditBtn type="button" onClick={onEdit}>
          Editar
        </EditBtn>
      )}
    </Head>
    <Rows>
      {rows.map((r) => (
        <Row key={r.label}>
          <RowLabel>{r.label}</RowLabel>
          <RowValue>{r.value || "—"}</RowValue>
        </Row>
      ))}
    </Rows>
  </Card>
)

const Card = styled.div`
  border: 1px solid var(--cards-border, #b7c0cd);
  border-radius: 10px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`
const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
const Title = styled.span`
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--general-primary, #0027d4);
`
const EditBtn = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 0.8125rem;
  color: var(--general-primary, #0027d4);
`
const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
`
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  font-size: 0.875rem;
`
const RowLabel = styled.span`
  color: var(--text-body, #64748b);
`
const RowValue = styled.span`
  color: var(--text-title, #0f172a);
  text-align: right;
`
